// services/divisionService.js
import api from "./api";

export const getAllDivisions = async (schemaName=null) => {
  try {
    const response = await api.get("/divisions/", {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching divisions:", error);
    throw error;
  }
};

export const getDivisionById = async (divisionId, schemaName=null) => {
  try {
    const response = await api.get(`/divisions/${divisionId}/`, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching division:", error);
    throw error;
  }
};

export const updateDivision = async (divisionId, divisionData, schemaName=null) => {
  try {
    const response = await api.put(`/divisions/${divisionId}/`, divisionData, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating division:", error);
    throw error;
  }
};

export const createDivision = async (divisionData, schemaName=null) => {
  try {
    const response = await api.post("/divisions/", divisionData, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating division:", error);
    throw error;
  }
};

export const deleteDivision = async (divisionId, schemaName=null) => {
  try {
    const response = await api.delete(`/divisions/${divisionId}/`, {
      params: { client: schemaName }
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting division:", error);
    throw error;
  }
};

// Optional: Add pagination support
export const getDivisionsWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    const response = await api.get("/divisions/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching divisions with pagination:", error);
    throw error;
  }
};

// Optional: Add bulk operations if needed
export const bulkCreateDivisions = async (divisionsData) => {
  try {
    const response = await api.post("/divisions/bulk-create/", divisionsData);
    return response.data;
  } catch (error) {
    console.error("Error bulk creating divisions:", error);
    throw error;
  }
};

export const bulkUpdateDivisions = async (divisionsData) => {
  try {
    const response = await api.put("/divisions/bulk-update/", divisionsData);
    return response.data;
  } catch (error) {
    console.error("Error bulk updating divisions:", error);
    throw error;
  }
};
